// Day/night. M0 follows the system setting; Settings (later) can force day or night
// by setting data-theme on <html>. We mirror the resolved theme to data-resolved-theme
// so the report and (later) the canvas renderer can read it.
export type Theme = 'day' | 'night';

export function watchSystemTheme(): void {
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const apply = (): void => {
    const forced = document.documentElement.dataset['theme'];
    const resolved: Theme =
      forced === 'day' || forced === 'night' ? forced : mq.matches ? 'night' : 'day';
    document.documentElement.dataset['resolvedTheme'] = resolved;
  };
  apply();
  mq.addEventListener('change', apply);
}
